import { createClient } from "@supabase/supabase-js";

// Replace these with your actual Supabase URL and public key
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "YOUR_SUPABASE_URL";
const supabaseAnonKey =
    import.meta.env.VITE_SUPABASE_ANON_KEY || "YOUR_SUPABASE_ANON_KEY";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    db: {
        schema: 'altzero'
    },
    auth: {
        // Enable session persistence
        persistSession: true,
        // Auto refresh session
        autoRefreshToken: true,
        // Detect session in URL
        detectSessionInUrl: true,
        // Storage key for session
        storageKey: 'supabase.auth.token',
        // Storage type
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
        // Flow type
        flowType: 'pkce'
    }
});

export const supabasePublic = createClient(supabaseUrl, supabaseAnonKey, {
    db: {
        schema: 'public'
    },
    auth: {
        // Enable session persistence
        persistSession: true,
        // Auto refresh session
        autoRefreshToken: true,
        // Detect session in URL
        detectSessionInUrl: true,
        // Storage key for session
        storageKey: 'supabase.auth.token',
        // Storage type
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
        // Flow type
        flowType: 'pkce'
    }
});
